export default __webpack_public_path__ + "ocr/worker.min-659051bf21f04d23ef64f43306ff257c.js";